import React from "react";
import DotsComponent from "./DotsComponent";
import SimpleImageSlider from "react-simple-image-slider";
import { marketplaceCardData as data } from "./OMSData";
import { useState, useEffect } from "react";



const OMSMarketplaceWindow = () => {
  const [style, setstyle] = useState({backgroundColor:'#F72E2E'})
  useEffect(() =>{
    if (data.availibility) {
      setstyle({backgroundColor:'#43991F'})
    } else {
      setstyle({backgroundColor:'#F72E2E'})
    }
  }, [])
  return (
    <div id="marketplaceOrderSmallWindow">
      <DotsComponent />
      <div className="market-card">
        <small className="detail-light purchase-head">Product Details</small>
        <div id="marketplaceDetail">
          <div className="order-details-head" style={style}>
            <b>{data.title}</b>
          </div>
          <div className="order-detail-id">
            <h3>Product Id: {data.productid}</h3>
            <small>Added On: {data.added}</small>
          </div>
          <div style={{ marginTop: "2rem" }}>
            <SimpleImageSlider
              width={350}
              height={350}
              images={data.images}
              showBullets={true}
              showNavs={true}
              bgColor={"#000000"}
            />
          </div>
          <div className="product-details">
            <div className="detail-dark edit-product">
              <a href="">Edit Product Details</a>
              <a href="">Save</a>
            </div>
            <div>
              <div className="edit-product-solo">
                <label className="detail-dark">Product Name: </label>
                <br />
                <input
                  placeholder="Product Name:"
                  className="product-detail-input"
                />
              </div>
              <div className="edit-product-solo">
                <label className="detail-dark">Quantity: </label>
                <br />
                <input
                  placeholder="Quantity"
                  className="product-detail-input"
                />
              </div>
              <div className="edit-product-solo">
                <label className="detail-dark">Brand Name: </label>
                <br />
                <input
                  placeholder="Brand Name"
                  className="product-detail-input"
                />
              </div>
              <div className="edit-product-solo">
                <label className="detail-dark">Description: </label>
                <br />
                <input
                  placeholder="Description"
                  className="product-detail-input"
                />
              </div>
              <div className="edit-product-solo">
                <label className="detail-dark">Product Price: </label>
                <br />
                <input
                  placeholder="Price"
                  className="product-detail-input"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OMSMarketplaceWindow;
